"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComparisonFeatures = exports.getInformation = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    information: {
        client: 'api/aem/product/productcode',
        server: 'enrichedproduct/productcode',
    },
    comparisonFeatures: {
        client: 'api/aem/product/features/comparison/{market}/{fictiveWebShop}/{productId}',
    },
};
const getInformation = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { productCode, colorId }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.information, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { productCode, colorId }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getInformation = getInformation;
const getComparisonFeatures = (_c, _d) => tslib_1.__awaiter(void 0, [_c, _d], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { fictiveWebShop, productId }) {
    const { market, language } = defaultRequestParams;
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.comparisonFeatures, isServer, {
        market,
        fictiveWebShop,
        productId,
    });
    const axiosConfig = {
        method: 'GET',
        url,
        params: { language },
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getComparisonFeatures = getComparisonFeatures;
//# sourceMappingURL=product.api.js.map